/* LOP | Rotación simple de mensajes del Announcement bar (sin dependencias). */
if (!customElements.get('announcement-slider')) {
  class AnnouncementSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement-slider__slide'));
      if (this.slides.length < 2) return;

      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.delay = Math.max(3, parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.hovered = false;
      this.focused = false;
      this.selected = false;

      // Pausa solo con mouse real (en touch no hay "leave" confiable) y con foco por teclado.
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stop();
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.start();
      });
      this.addEventListener('focusin', (event) => {
        if (!event.target.matches(':focus-visible')) return;
        this.focused = true;
        this.stop();
      });
      this.addEventListener('focusout', () => {
        if (!this.focused) return;
        this.focused = false;
        this.start();
      });

      // Flechas: cambian de mensaje y reinician el timer del autoplay.
      this.querySelectorAll('.announcement-slider__arrow').forEach((button) => {
        button.addEventListener('click', () => {
          this.show(this.index + (button.name === 'prev' ? -1 : 1));
          this.start();
        });
      });

      // Theme editor: mostrar el bloque seleccionado y frenar la rotación mientras está seleccionado.
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target);
        if (index === -1) return;
        this.selected = true;
        this.stop();
        this.show(index);
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.selected = false;
        this.start();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      if (this.hovered || this.focused || this.selected) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    show(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
    }
  }

  customElements.define('announcement-slider', AnnouncementSlider);
}
